import { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  Outlet,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { fetchUser } from "./redux/actions/userAction"
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { authAPI } from './services/AuthAPI';
import Login from './pages/login';
import ForgetPassword from "./pages/forgetpassword"
import ForegetPasswordConfirm from './pages/forgetpasswordconfirm';
import Menu from './pages/menu'
import Document from './pages/document';
import Export_Docs from "./pages/export_docs"
import EditProfile from './pages/edit_profile';
import ManageType from './pages/managetype';
import AddType from "./pages/addtype"
import AddPrefix from './pages/addprefix';
import EditTpye from './pages/edittype';
import ManagePrefix from "./pages/manageprefix"
import EditPrefix from "./pages/editprefix"
import PDPAPage from "./pages/pdpa"
import AcceptableUsePage from './pages/AcceptableUse'
import PDPAManage from "./pages/managepdpa"
import ManageAcceptableUse from "./pages/manageAcceptableUse"
import View_PDPA from './pages/viewpdpa';
import User_Detail from './pages/user_detail';
import Swal from "sweetalert2"
import { USER_UPDATE } from "./redux/types"
import './App.css';

const App = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const Token = localStorage.getItem("Token")
  const { user: { isLogin, isLoading, userData, loadingGetPrefix }, type: { isLoadingType, isLoadingTypeAdmin } } = useSelector(state => state)
  const dispatch = useDispatch();
  const [width, setWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState(window.innerWidth > 1024 ? false : true)
  const [loadingPrefix, setLoadingPrefix] = useState(false)
  const [closeNav, setCloseNav] = useState(isMobile ? true : false)
  useEffect(() => {
    if (Token) {
      dispatch(fetchUser());
    }
    else if (!(location.pathname == '/login' || location.pathname.includes("forget-password"))) {
      navigate("/login")
    }
  }, [])

  useEffect(() => {
    const Upsize = () => {
      setWidth(window.innerWidth)
    }
    window.addEventListener("resize", Upsize)
    return () => {
      window.removeEventListener("resize", Upsize)
    }
  }, [])

  useEffect(() => {
    if (width > 1024) {
      setIsMobile(false)
    }
    else {
      setIsMobile(true)
    }
  }, [width])

  useEffect(() => {
    if (isLogin && !userData.email) {
      Swal.fire({
        customClass: {
          popup: 'swalemailwidth'
        },
        title: "โปรดป้อนอีเมลของคุณ สำหรับกรณีลืมรหัสผ่าน",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        confirmButtonColor: "#6ab23a",
        showCancelButton: true,
        confirmButtonText: "เรียบร้อย",
        showLoaderOnConfirm: true,
        preConfirm: (email) => {
          try {
            let checkformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (!email) throw { message: "โปรดป้อนอีเมลของคุณ" }
            let checkemail = checkformat.test(email)
            if (!checkemail) throw { message: "รูปแบบอีเมลไม่ถูกต้อง" }
            return authAPI.updateEmail(email)
              .then(res => {
                if (res.status != 200) {
                  throw new Error(res.message);
                }
                return res;
              })
              .catch(error => {
                Swal.showValidationMessage(error.message);
              });
          } catch (error) {
            Swal.showValidationMessage(error.message);
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => {
        Swal.fire({
          icon: 'success',
          confirmButtonColor: "#6ab23a",
          text: `ยืนยันเปลี่ยนที่อยู่อีเมลใหม่เป็น ${result.value.message.email} เรียบร้อย`,
          timer: 5000
        })
          .then(() => {
            if (result.value.token) {
              localStorage.setItem("Token", result.value.token)
            }
            dispatch({ type: USER_UPDATE, payload: result.value.message })
          })
      });
    }
  }, [userData])

  const useStyles = makeStyles((theme) => ({
    backdrop: {
      color: '#fff',
      zIndex: theme.zIndex.drawer + 1,
    }
  }))

  const classes = useStyles()

  return (
    <div style={{ display: !isLogin ? 'block' : 'flex' }}>
      {userData && <Backdrop className={classes.backdrop} open={isLoading || isLoadingType || isLoadingTypeAdmin || loadingGetPrefix || loadingPrefix} >
        <CircularProgress size={50} style={{ color: '#6ab23a' }} />
      </Backdrop>}
      {isLogin && <Menu isMobile={isMobile} closeNav={closeNav} setCloseNav={setCloseNav} />}
      <Routes >
        <Route path="/" element={!isLogin && !(location.pathname == '/login' || location.pathname.includes("forget-password")) ? <Login /> : <Outlet />}>
          <Route path="login" element={!isLogin ? <Login /> : !isLoading && <Navigate to="/" />} />
          <Route path="forget-password/:_id" element={!isLogin ? <ForegetPasswordConfirm /> : !isLoading && <Navigate to="/" />} />
          <Route path="forget-password" element={!isLogin ? <ForgetPassword /> : !isLoading && <Navigate to="/" />} />
          <Route path="user-detail" element={userData?.permission?.detail_user ? <User_Detail isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/" />} />
          <Route path="export_docs" element={userData?.permission?.manage_contract ? <Export_Docs isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/login" />} />
          {isLogin && <Route path="pdpa" element={isLogin ? <PDPAPage isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/login" />} />}
          {isLogin && <Route path="acceptable-use" element={isLogin ? <AcceptableUsePage isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/login" />} />}
          {isLogin && <Route path="document" element={isLogin ? <Document isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/login" />} />}
          {isLogin && <Route path="edit_profile" element={isLogin ? <EditProfile isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/login" />} />}
          <Route
            index
            element={isLogin ? <Document isMobile={isMobile} closeNav={closeNav} /> : !isLoading && <Navigate to="/login" />} />
          {isLogin && userData && (userData?.permission?.add_type || userData?.permission?.edit_type) &&
            <Route path="/manage-type" element={<Outlet />}>
              {userData.permission.add_type && <Route path="add-type" element={<AddType isMobile={isMobile} closeNav={closeNav} />} />}
              {userData.permission.edit_type && <Route path="edit-type/:_id" element={<EditTpye isMobile={isMobile} closeNav={closeNav} />} />}
              <Route
                index
                element={<ManageType isMobile={isMobile} closeNav={closeNav} />} />
            </Route>}
          {isLogin && userData && (userData?.permission?.add_prefix || userData?.permission?.edit_prefix) &&
            <Route path="/manage-prefix" element={<Outlet />}>
              {userData?.permission?.add_prefix && <Route path="add-prefix" element={<AddPrefix isMobile={isMobile} closeNav={closeNav} />} />}
              {userData?.permission?.edit_prefix && <Route path="edit-prefix/:_id" element={<EditPrefix isMobile={isMobile} closeNav={closeNav} />} />}
              <Route
                index
                element={<ManagePrefix isMobile={isMobile} closeNav={closeNav} />} />
            </Route>}

          {isLogin && userData && (userData?.permission?.manage_pdpa) &&
            <Route path="/manage-pdpa" element={<Outlet />}>
              <Route path="view-pdpa/:_id" element={<View_PDPA isMobile={isMobile} closeNav={closeNav} />} />
              <Route
                index
                element={<PDPAManage isMobile={isMobile} closeNav={closeNav} />} />
            </Route>}
          {isLogin && userData && (userData?.permission?.manage_acceptable_use) && 
            <Route path="/manage-acceptable-use" element={<Outlet />}>
              <Route
                index
                element={<ManageAcceptableUse isMobile={isMobile} closeNav={closeNav} />} />
            </Route>}
          <Route path="*" element={isLogin ? <Document isMobile={isMobile} closeNav={closeNav} /> : <Login />} />
          <Route path="/" exact element={isLogin ? <Document isMobile={isMobile} closeNav={closeNav} /> : <Login />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;